import { w } from "@/api/words";

import type { SurfaceMeta } from "../registry";

// Объявление поверхности S-10 «Стан даних». Читается при сборке: тека с этим
// файлом — это и есть регистрация, общих файлов при этом никто не правит.
//
// ⚠ Поверхность выдаётся отметкой пресета и стоит в меню **с первого дня**
// (`docs/SCREEN-MAP.md:1041`): отложенной она не бывает. Второй вход на неё —
// клик по индикатору свежести в шапке, и он сквозной.
export const meta: SurfaceMeta = {
  code: "S-10",
  // Название — слово словаря по коду (`G117`, таск 74), читается при показе.
  get title_uk() {
    return w("s10_title");
  },
  path: "/s-10",
};
